import { T as TimeFormat } from './TimeFormat-a7f5565b.js';

const formatDate = (value, format, locale) => {
  if (typeof format === 'function') {
    return format(value, locale);
  }
  return value.toLocaleString(locale, {
    dateStyle: format,
    timeZone: 'UTC'
  });
};

const formatTime = (value, format, locale) => {
  if (typeof format === 'function') {
    return format(value, locale);
  }
  return value.toLocaleString(locale, {
    timeStyle: 'short',
    hourCycle: format !== TimeFormat.Auto ? format : undefined,
    timeZone: 'UTC'
  });
};

export { formatTime as a, formatDate as f };
